var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundedArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 7.99992C0.25 5.00815 2.6749 2.58325 5.66667 2.58325H10.3333C10.7475 2.58325 11.0833 2.91904 11.0833 3.33325C11.0833 3.74747 10.7475 4.08325 10.3333 4.08325H5.66667C3.50332 4.08325 1.75 5.83658 1.75 7.99992C1.75 9.24636 2.33363 10.3549 3.24565 11.0744C3.57085 11.331 3.62648 11.8026 3.36992 12.1278C3.11337 12.453 2.64176 12.5086 2.31657 12.2521C1.06171 11.262 0.25 9.7277 0.25 7.99992Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6299 3.87216C12.8865 3.54697 13.3581 3.49133 13.6833 3.74789C14.9381 4.7379 15.7498 6.27226 15.7498 8.00003C15.7498 10.9918 13.3249 13.4167 10.3332 13.4167H5.6665C5.25229 13.4167 4.9165 13.0809 4.9165 12.6667C4.9165 12.2525 5.25229 11.9167 5.6665 11.9167H10.3332C12.4965 11.9167 14.2498 10.1634 14.2498 8.00003C14.2498 6.75359 13.6662 5.64505 12.7542 4.92551C12.429 4.66896 12.3734 4.19735 12.6299 3.87216Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14128 10.1918C8.43417 10.4847 8.43417 10.9596 8.14128 11.2525L6.72716 12.6666L8.14128 14.0807C8.43417 14.3736 8.43417 14.8485 8.14128 15.1414C7.84839 15.4343 7.37351 15.4343 7.08062 15.1414L5.13617 13.1969C4.84328 12.904 4.84328 12.4292 5.13617 12.1363L7.08062 10.1918C7.37351 9.89894 7.84839 9.89894 8.14128 10.1918Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85834 0.858586C8.15123 0.565693 8.62611 0.565693 8.919 0.858586L10.8634 2.80303C11.1563 3.09592 11.1563 3.5708 10.8634 3.86369L8.919 5.80814C8.62611 6.10103 8.15123 6.10103 7.85834 5.80814C7.56545 5.51524 7.56545 5.04037 7.85834 4.74747L9.27246 3.33336L7.85834 1.91925C7.56545 1.62635 7.56545 1.15148 7.85834 0.858586Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedArrows);
export default __webpack_public_path__ + "static/media/icon-rounded-arrows.b3593ca9cc1e0be44fbddd64c1c88c9a.svg";
export { ForwardRef as ReactComponent };